import {momentRange} from "../../../../../../gd/convert/moment-range";
import {TimeReportType} from "../../../../../../../views/reports/time-reports/@types";
import formatDaterange from "../../../../../../gd/format/daterange";


export default class ReportEffortsDistributionByUser_Settings {

    public daterange      : DateRange
    public userId         : ID
    public timeReportType : TimeReportType


    constructor(data: any) {
        this.daterange      = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.userId         = _.get(data, "userId", null)
        this.timeReportType = _.get(data, "timeReportType", TimeReportType.REPORTED)

    }

    // get reportTitle() {
    //     const user = gd.session.users.get(this.userId)
    //     if(user){
    //         return user.name
    //     }
    //     else{
    //         return ""
    //     }
    // }

    toJSON(): JSONObject {
        const result: JSONObject = {
            userId      : this.userId,
            timeReportType   : this.timeReportType,
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
